import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
} from '@material-ui/core';
import { addAreaParameter } from '../areaParameters/areaParametersServices';
import { getNewAreaParam } from '../Constants';

function EditAreaParameter({
  isModalOpen,
  toggleModal,
  parameterToAdd,
  areaId,
  addNewAreaParameter,
}) {
  const [newAreaParam, updateNewAreaParam] = useState(
    getNewAreaParam(areaId, parameterToAdd)
  );

  const onAddAreaParameter = () => {
    addNewAreaParameter(newAreaParam, () => {
      toggleModal(false);
    });
  };

  return (
    <Dialog open={isModalOpen}>
      <DialogTitle>Add Parameter</DialogTitle>
      <DialogContent>
        <Grid container style={{ flexGrow: 1 }} justify="center">
          <Grid
            container
            style={{ flexGrow: 1, marginBottom: 16 }}
            justify="space-between"
          >
            <Grid item>
              <Typography>Name</Typography>
              <Typography variant="button">{parameterToAdd.name}</Typography>
            </Grid>
            <Grid item>
              <Typography>Default Importance</Typography>
              <Typography variant="button">
                {parameterToAdd.importance}
              </Typography>
            </Grid>
          </Grid>
          <TextField
            id="importance"
            label="Importance"
            variant="outlined"
            fullWidth
            value={newAreaParam.importance}
            onChange={(e) =>
              updateNewAreaParam({
                ...newAreaParam,
                importance: e.target.value,
              })
            }
            required
            type="number"
            error={
              !newAreaParam.importance ||
              newAreaParam.importance < 1 ||
              newAreaParam.importance > 5
            }
            helperText={
              newAreaParam.importance !== '' &&
              (newAreaParam.importance < 1 || newAreaParam.importance > 5) &&
              'Importance value must be between 1 to 5'
            }
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={!newAreaParam.importance}
          variant="outlined"
          color="primary"
          onClick={onAddAreaParameter}
        >
          Add
        </Button>
        <Button
          variant="outlined"
          onClick={() => toggleModal(false)}
          color="secondary"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  addNewAreaParameter: (parameter, cb) =>
    dispatch(addAreaParameter(parameter, cb)),
});

export default connect(null, mapDispatchToProps)(EditAreaParameter);



// WEBPACK FOOTER //
// ./src/parameter/NewAreaParam.js